<template>
  <section >
    <v-row justify="center">
      <v-col cols="6" class="text-center">
        <v-row align="center">
          <v-icon x-large color="green">fas fa-check-circle</v-icon>
          <v-icon x-large  color="green" >mdi-table</v-icon>
          <div>
            <h3 class="title">Your Invoice file has been checked</h3>
          </div>
        </v-row>

      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="tab-a">
      <v-tabs
        v-model="tab"
        grow
        :slider-color="tab === 0 ? 'cyan accent-4' : 'red'"
        class="tab-a"
      >
        <v-tab key="0"  >
          <v-icon class="mr-12" color="green" small>fas fa-check-circle</v-icon>
          Accepted
          <v-icon class="px-12" color="green"  @click="getProcessedCSV()" >
            cloud_download
          </v-icon>
          <v-tooltip top color="secondary" class="white--text">
            <span>Invoices that will be accepted, click the green cloud to download corresponding lines from the original invoice</span>
            <template v-slot:activator="{ on }">
              <v-icon class="pl-2" v-on="on">info</v-icon>
            </template>
          </v-tooltip>
        </v-tab>
        <v-tab key="1"  @click = "toggleExpandRejected()">
          <v-icon class="mr-12" color="red" small>fas fa-times-circle</v-icon>
          Invalid
          <v-icon class="px-12" color="red" @click="getRejectedCSV()" >
            cloud_download
          </v-icon>
          <v-tooltip top color="secondary" class="white--text">
            <span>Invoices that will be rejected, click the red cloud to download corresponding lines from the original Invoices</span>
            <template v-slot:activator="{ on }">
              <v-icon class="pl-2" v-on="on">info</v-icon>
            </template>
          </v-tooltip>
        </v-tab>

        <v-tabs-items v-model="tab" >
          <v-tab-item :key="0" >
            <v-card >
            <v-data-table
              :headers="invoiceHeaders"
              :items="renderedProcessedProps"
              :loading="loading"
              item-key="id"
              :expanded="expandedItems"
              show-expand
              :single-expand="false"

            >
              <template v-slot:item="{ item, isExpanded }">
                <tr @click="toggleExpand(item)" class="id-column" >
                  <td >{{  }}</td>
                  <td >{{ item.id }}</td>
                  <td>{{ item.client_name }}</td>
                  <td>{{ item.state }}</td>
                  <td>{{ item.postcode }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ item.total }}</td>
                </tr>
              </template>

              <!-- Expanded Row -->
                <template v-slot:expanded-item="props">
                <tr>
                  <td colspan="7">
                    <v-data-table
                      :headers="headersAccept"
                      :items="props.item.invoicesData"
                      hide-default-footer
                      dense
                    >
                      <template v-slot:item="props">
                        <tr>
                          <td v-for="(header, index) in headersAccept" :key="index" style="text-align: center;">
                            {{ props.item[header.value] }}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </td>
                </tr>
              </template>
            </v-data-table>
            </v-card>
          </v-tab-item>

          <v-tab-item :key="1">
            <v-data-table
              :headers="invoiceRejectedHeaders"
              :items="renderedRejectedProps"
              :loading="loading"
              item-key="id"
              :expanded="expandedItemsRejected"
              show-expand
              :single-expand="true"
            >
              <template v-slot:item="{ item, isExpandedRejected }">
                <tr @click="toggleExpandRejected(item)" class="id-column-rejected" >
                  <td >{{ }}</td>
                  <td >{{ item.id }}</td>
                  <td>{{ item.client_name }}</td>
                  <td>{{ item.state }}</td>
                  <td>{{ item.postcode }}</td>
                  <td>{{ item.date }}</td>
                  <td>{{ item.total }}</td>
                </tr>
              </template>
              <!-- Expanded Row -->
              <template v-slot:expanded-item="props">
                <tr>
                  <td colspan="8">
                    <v-data-table
                      :headers="headers"
                      :items="props.item.invoicesData"
                      hide-default-footer
                      dense
                    >
                      <template v-slot:item="props">
                        <tr>
                          <td v-if="header.text !== 'Reject Reason'" v-for="(header, index) in headers" :key="index" style="text-align: center;">
                            {{ props.item[header.value] }}
                          </td>
                          <td v-else style="text-align: center" @click="displayInfo(props.item)">
                              <v-row>
                                <v-col cols="12">
                                  <v-tooltip top color="secondary">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="red" v-on="on" small>info</v-icon>
                                    </template>
                                    <span>
                                        {{ props.item.validation_errors.join("; ") }}
                                    </span>
                                  </v-tooltip>
                                </v-col>
                                <v-col cols="12">
                                  {{ props.item.invoice}}
                                </v-col>
                              </v-row>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>

      </v-tabs>
    </v-row>


    <v-row justify="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
      <v-tooltip top color="secondary" class="white--text">
        <template v-slot:activator="{ on }">
          <v-btn text color="blue-grey lighten-2" v-on="on" @click="$emit('back-to-upload')">
            Cancel
          </v-btn>
        </template>
        <span>Go back to submitting the Invoices file</span>
      </v-tooltip>
      <v-btn text outlined color="blue darken-1" @click="confirmDialog=true">Confirm</v-btn>
    </v-row>

    <v-dialog
      v-model="confirmDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="text-center">
          Are you sure you want to confirm this invoices ?
        </v-card-title>
        <v-card-text>
          {{confirmMessage}}
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="confirmDialog = false">No</v-btn>
          <v-btn text @click="$emit('file-confirmed'); confirmDialog=false" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: "InvoiceUploadConfirmation",
  components: {

  },
  props: {
    dataTableProps: Object,
    jobId: String,
  },
  data() {
    return {
      invoiceHeaders: [
        { text: 'Id', value: 'id', align: 'center', sortable: true, width: '10%'},
        { text: 'Client Name', value: 'client_name', align: 'center', sortable: true , width: '20%'},
        { text: 'State', value: 'state', align: 'center', sortable: true, width: '15%' },
        { text: 'Postcode', value: 'postcode', align: 'center', sortable: true , width: '15%'},
        { text: 'Invoice Date', value: 'date', align: 'center', sortable: true , width: '20%'},
        { text: 'Total', value: 'total', align: 'center', sortable: true , width: '20%'},
      ],
      headersAccept:[
         //{text: 'Id', value: 'id', align: 'center', sortable: false,width: '8%'},
        {text: 'Region', value: 'region_name', align: 'center', sortable: false,width: '8%'},
        {text: 'Description', value: 'description', align: 'center', sortable: false,width: '20%'},
        {text: 'UOM', value: 'uom', align: 'center', sortable: false,width: '15%'},
        {text: 'Quantity', value: 'quantity', align: 'center', sortable: true,width: '15%'},
        {text: 'Unit Price', value: 'unit_price', align: 'center', sortable: true,width: '10%'},
        {text: 'Date', value: 'date', align: 'center', sortable: false,width: '10%'},
        {text: 'Fuel Levy', value: 'fuel_levy', align: 'center', sortable: false,width: '10%'},
        {text: 'Amount', value: 'amount', align: 'center', sortable: true,width: '10%'}
      ],
      invoiceRejectedHeaders: [
        { text: 'Id', value: 'id', align: 'center', sortable: false, width: '15%'},
        { text: 'Client Name', value: 'client_name', align: 'center', sortable: false , width: '20%'},
        { text: 'State', value: 'state', align: 'center', sortable: false, width: '20%' },
        { text: 'Postcode', value: 'postcode', align: 'center', sortable: false , width: '20%'},
        { text: 'Invoice Date', value: 'date', align: 'center', sortable: false , width: '20%'},
        { text: 'Total', value: 'total', align: 'center', sortable: true , width: '25%'}
      ],
      headers: [
        {text: 'Region', value: 'region_name', align: 'center', sortable: false,width: '8%'},
        {text: 'Description', value: 'description', align: 'center', sortable: false,width: '20%'},
        {text: 'UOM', value: 'uom', align: 'center', sortable: false,width: '15%'},
        {text: 'Quantity', value: 'quantity', align: 'center', sortable: true,width: '15%'},
        {text: 'Unit Price', value: 'unit_price', align: 'center', sortable: true,width: '10%'},
        {text: 'Date', value: 'date', align: 'center', sortable: false,width: '10%'},
        {text: 'Fuel Levy', value: 'fuel_levy', align: 'center', sortable: false,width: '10%'},
        {text: 'Amount', value: 'amount', align: 'center', sortable: true,width: '10%'},
        {text: 'Reject Reason', value: 'reject', align: 'center', sortable: true,width: '20%'}
      ],
      rowInfo: null,
      expandedItems: [],
      expandedItemsRejected: [],
      creditNoteDisplayerDialog: false,
      showInfo: false,
      tab: 0,
      confirmDialog: false,
      loading:false
    }
  },
  methods: {
    displayInfo(item) {
      this.rowInfo = item;
      if (item !== null && item !== undefined) {
        this.showInfo = true;
      }
    },
    getProcessedCSV() {
      window.open(process.env.API_URL + '/invoices/' + this.jobId + '/interim/processed?key=' + encodeURI(this.$store.state.auth.key), '_blank')
    },
    getRejectedCSV() {
      window.open(process.env.API_URL + '/invoices/' + this.jobId + '/interim/rejected?key=' + encodeURI(this.$store.state.auth.key), '_blank')
    },
    toggleExpand(item) {
      if (this.expandedItems.findIndex(x => x.id === item.id) === -1) {
        this.expandedItems.push(item);
      } else {
        this.expandedItems = this.expandedItems.filter(x => x.id !== item.id);
      }
    },
    isExpanded(item) {
      return this.expandedItems.includes(item);
    },
    toggleExpandRejected(item) {
      const index = this.expandedItemsRejected.indexOf(item);
      if (index >= 0) {
        this.expandedItemsRejected.splice(index, 1);  // Collapse
      } else {
        this.expandedItemsRejected.push(item);
      }

        // if (item && item.id) {
        //     if (this.expandedItemsRejected.findIndex(x => x.id === item.id) === -1) {
        //       this.expandedItemsRejected.push(item);
        //     } else {
        //       this.expandedItemsRejected = this.expandedItemsRejected.filter(x => x.id !== item.id);
        //     }
        // } else {
        //     console.error('Item or item.id is undefined:', item);
        // }

    },
    isExpandedRejected(item) {
      return this.expandedItemsRejected.includes(item);
    },


  },
  computed: {
    renderedProcessedProps() {

      this.dataTableProps.processed.map((row) => {
        let amount = 0;
        if (row.invoicesData !== undefined && row.invoicesData.length > 0) {
          for (var i = 0; i < row.invoicesData.length; i++) {
            amount += parseFloat(row.invoicesData[i].amount);
            this.renderedRegions.forEach((region) => {
              if(row.invoicesData[i].region === region.id) {
                row.invoicesData[i].region_name = region.name;
              }
            });
          }
          row.total = parseFloat(amount.toFixed(2));
        }
      });

     return this.dataTableProps.processed;
    },
    renderedRejectedProps() {

      this.dataTableProps.rejected.map((row) => {
        let amount = 0;
        if (row.invoicesData !== undefined && row.invoicesData.length > 0) {
          for (var i = 0; i < row.invoicesData.length; i++) {
            amount += parseFloat(row.invoicesData[i].amount);
            this.renderedRegions.forEach((region) => {
              if(row.invoicesData[i].region === region.id) {
                row.invoicesData[i].region_name = region.name;
              }
            });
          }
          row.total = parseFloat(amount.toFixed(2));
        }
      });

      return this.dataTableProps.rejected;

    },
    renderedRegions() {
      if (this.Regions === null || this.Regions === undefined) {
        return [];
      } else {
        return this.Regions;
      }
    },
    confirmMessage() {
      if (this.renderedRejectedProps.length === 0) {
        return null
      } else {
        return 'Please note that you have ' + this.renderedRejectedProps.length + ' rejected lines. \n These lines won\'t be processed.'
      }
    },
    editRow(){

    },
    deleteRow(){

    }
  },
  asyncComputed: {
    async Regions() {
      if (this.reload || !this.reload) {
        this.loading = true;
        return await axios.get(process.env.API_URL + '/regions')
          .then((response) => {
            if (response.status === 200) {
              this.loading = false;
              return response.data;
            } else {
              this.loading = false;
              return [];
            }
          })
          .catch((error) => {
            this.loading = false;
            return [];
          });
      }
    }
  },

}
</script>

<style scoped>

.title{
  margin-left: 100px;
}

.tab-a{
  margin-left: 0; /* Adjust the value to move it further left */
  padding-left: 0;
}

.id-column{
 background-color: lightgray;
  text-align: center;
  cursor: pointer;
}

.id-column-rejected{
  background-color: lightcoral;
  text-align: center;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/util/Invoices/InvoiceUploadConfirmation.vue